import * as React from "react"
import { WeekDays, Day, getDayName } from "../../../api/Randoms/GovPoolModel/DayOfWeek"
import DaysToExclude from "../../../api/Randoms/GovPoolModel/DaysToExclude"
import Checkbox from "../../Checkbox"
import { parseISO } from "date-fns"

interface WeekdaysToExcludeProps {
  daysToExclude: DaysToExclude[]
  editable?: boolean
  handlerChange: (e: React.ChangeEvent<HTMLInputElement>, day: Day) => void
}

export class WeekdaysToExclude extends React.PureComponent<WeekdaysToExcludeProps> {
  valueText = (daysToExclude: DaysToExclude[]) => {
    return [
      ...daysToExclude.filter(item => item.DayOfWeekID).map(item => item.DayOfWeekID).sort().map(day => getDayName(day!)),
    ].join(", ")
  }

  render() {
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()
    // Remove past dates
    const daysToExclude = this.props.daysToExclude.filter(item => item.DayOfWeekID || (item.DateExclude && parseISO(item.DateExclude)?.getTime() >= today))
    const weekdaysToExclude = daysToExclude.filter(item => item.DayOfWeekID).map(item => item.DayOfWeekID as Day)
    return <>
      {!this.props.editable && this.valueText(daysToExclude)}
      {this.props.editable &&
        WeekDays.map(
          day => {
            const checkbox = <Checkbox
              inline
              id={day.Name}
              label={day.Name}
              key={day.Name}
              defaultChecked={this.props.daysToExclude && weekdaysToExclude.includes(day.Id)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => { this.props.handlerChange(e, day.Id) }}
            />
            return checkbox
          }
        )}
    </>
  }
}
